var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabelL(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 42,
    stroke: "white",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.44 66.824C33.8427 66.824 33.3627 66.8133 33 66.792C32.6373 66.7493 32.1787 66.632 31.624 66.44C31.0907 66.248 30.632 65.96 30.248 65.576C29.864 65.192 29.576 64.7333 29.384 64.2C29.192 63.6453 29.0747 63.1867 29.032 62.824C29.0107 62.4613 29 61.9813 29 61.384V27.016C29 25.928 29.032 25.1387 29.096 24.648C29.1813 24.1573 29.352 23.6453 29.608 23.112C29.9493 22.472 30.4613 21.96 31.144 21.576C31.848 21.192 32.6267 21 33.48 21C34.3333 21 35.1013 21.192 35.784 21.576C36.488 21.96 37.0107 22.472 37.352 23.112C37.608 23.6453 37.768 24.1573 37.832 24.648C37.9173 25.1387 37.96 25.928 37.96 27.016V58.888H53.48C55.144 58.888 56.3067 59.0587 56.968 59.4C57.544 59.6987 58.0027 60.1573 58.344 60.776C58.6853 61.3947 58.856 62.088 58.856 62.856C58.856 63.624 58.6853 64.3173 58.344 64.936C58.0027 65.5547 57.544 66.0133 56.968 66.312C56.3067 66.6533 55.144 66.824 53.48 66.824H34.44Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelL);
export default __webpack_public_path__ + "static/media/labelL.a57666ea86786c7f6c1cc3e423e26d50.svg";
export { ForwardRef as ReactComponent };